// GetPageMetaData returns the meta data for the wishlist page
export const WishlistMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then((m) => m.WishlistMetaService_GetPageMetaData);
WishlistMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.wishlist.v1.page.meta.WishlistMetaService/GetPageMetaData" as const;
